import { cn } from "@/lib/utils/cn";
import { createElement, forwardRef } from "react";
import { textVariants, type TextVariantProps } from "./textVariants";

type TextElement =
  | "a"
  | "div"
  | "span"
  | "p"
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6";

export type TextProps = {
  as?: TextElement;
  children: React.ReactNode;
  className?: string;
} & TextVariantProps &
  Omit<
    React.HTMLAttributes<HTMLElement> &
      React.AnchorHTMLAttributes<HTMLAnchorElement>,
    "color" | "children" | "className"
  >;

export const Text = forwardRef<HTMLElement, TextProps>(
  ({ as: Tag = "div", children, variant, color, className, ...rest }, ref) =>
    createElement(
      Tag,
      {
        ...rest,
        ref,
        className: cn(
          textVariants({ variant }),
          color != null && textVariants({ color }),
          className,
        ),
      },
      children,
    ),
);
Text.displayName = "Text";
